<template>
  <div class="container">
    <div class="content">
      <div class="anchor2">
        <div @click="show=!show" class="clickArea">{{$t('m.OnThisPage')}}<i class="el-icon-arrow-down"></i> </div>
        <div v-if="show">
          <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">订单匹配系统背景</a></p>
          <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">匹配过程</a></p>
          <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">基准价格选择算法</a></p>
          <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">以基准价格作为交易价格进行匹配</a></p>
          <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">基准价格算法示例</a></p>
          <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">匹配优先机制</a></p>
          <!-- <div class="subAnchor">
            <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
            <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
            <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
            <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
            <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
            <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
            <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
          </div> -->
        </div>
      </div>
      <div class="p1">匹配系统</div>
      <div id="box1" class="p4">订单匹配系统背景</div>
      <div class="p3">DEX的撮合系统采用集合竞价机制。由于在区块链系统中，订单不是连续下达的，而是按照出块时间的先后顺序排序的，因此与大多数中心化交易所不同，DEX 不使用连续拍卖算法来处理订单。相反，它会根据块生成间隔和集合拍卖的方式定期匹配订单。</div>
      <div class="p3">每个区块采用集合竞价方式，保证一个交易对在一个区块内只有一个成交价。交易完成后，按价格和时间优先执行。这有助于极大地降低区块内交易的排序对最终匹配结果的影响，增加矿工抢前的难度，降低矿工在抢前时的收益率，从而保证交易的公平性。</div>
      <div id="box2" class="p4">匹配过程</div>
      <div class="p3"><img style="width:40%;height:100%" src="@/assets/img/match1.png" alt=""></div>
      <div id="box3" class="p4">基准价格选择算法</div>
      <div class="p3">
        <ul style="padding-left:30px;word-break:break-all">
          <li>规则0：Best bid < best ask，没有订单可以执行，所以没有匹配。</li>
          <li>规则1：最大体积原则。当以基准价格执行交易时，达到最大交易量。如果多个价格可以达到最大交易量，则继续下一步。</li>
          <li>规则2：最小超额原则。超额是指在当前价格下，累计买入订单总数与累计卖出订单总数之间的差额。最小超额原则是指从满足规则1的价格中选择最小的绝对超额值。如果有多个满足规则的价格，则进行下一步。</li>
          <li>规则3：市场压力原则。如果有多个价格同时满足规则 1 和规则 2（最大值为 max，最小值为 min），则需要确定潜在价格的市场压力位置。如果超额值都是正数，这意味着买多卖少，有买压；如果超额值都是负数，这意味着买少卖多，有卖压；如果同时存在正负超值，则表示没有明显的买入或卖出压力。根据以下规则确定参考价格（ref）。如果ref在[min,max]范围内，则以ref为参考价；如果 ref 超出 [min, max] 的范围，则取最接近 ref 的 min 或 max 作为参考价格。</li>
          <div class="p3">
            <ul style="padding-left:30px;word-break:break-all">
              <li>规则 3a：如果超值都是正数，则存在买方压力。105% X 前成交价作为参考价。</li>
              <li>规则 3b：如果超额价值全部为负，则存在卖方压力。95% X 最新成交价作为参考价。</li>
              <li>规则 3c：如果存在正负超值，则没有明显的买入或卖出压力。以最新成交价为参考价。</li>
            </ul>
          </div>
        </ul>
      </div>
      <div class="p3"><img style="width:100%;height:100%" src="@/assets/img/match2.png" alt=""></div>
      <div id="box4" class="p4">以基准价格作为交易价格进行匹配</div>
      <div class="p3">所有买盘均按限价降序排列，所有卖盘均按限价升序排列。相同价格的订单按时间排序（区块高度和区块内的tx序列），较早时间的订单排在最前面。</div>
      <div class="p3">选择基准价格后，先列出的买单和卖单将按照最大成交量的顺序依次执行，即按价格和时间优先执行订单，直至全部成交。所有订单均以相同的基准价格执行。</div>
      <div id="box5" class="p4">基准价格算法示例</div>
      <div class="p3">选择的基准价格用*表示。</div>
      <div class="p3">可交易量 = MIN（累计卖单数，累计买单数）</div>
      <div class="p3">未成交量（超额）=累计买单数量-累计卖单数量</div>
      <div id="box6" class="p4">匹配优先机制</div>
      <div class="p3">在 FaxChain 网络中，由于 FAX 持有者有能力在 DEX 上列出他们自己的代币对，因此会有更多不同产品的订单涌入一个区块。</div>
      <div class="p3">节点的 CPU 资源无法在一个区块时间内完全匹配区块内订单。</div>
      <div class="p3">撮合优先机制通过撮合押金确定产品撮合顺序。所有者可以将更多的FAX作为撮合储备存入自己的产品中，以获得更高的撮合优先级。同时，所有者将获得所有匹配结果的所有交易费用，并以自己的产品作为奖励。</div>

      
    </div>
    
    <div class="wrapper">
    <div class="anchor1">
      <p @click="activeted(1)" class="s1"><a :class="{active:flag==1}" href="#box1">订单匹配系统背景</a></p>
      <p @click="activeted(2)" class="s1"><a :class="{active:flag==2}" href="#box2">匹配过程</a></p>
      <p @click="activeted(3)" class="s1"><a :class="{active:flag==3}" href="#box3">基准价格选择算法</a></p>
      <p @click="activeted(4)" class="s1"><a :class="{active:flag==4}" href="#box4">以基准价格作为交易价格进行匹配</a></p>
      <p @click="activeted(5)" class="s1"><a :class="{active:flag==5}" href="#box5">基准价格算法示例</a></p>
      <p @click="activeted(6)" class="s1"><a :class="{active:flag==6}" href="#box6">匹配优先机制</a></p>
      <!-- <div class="subAnchor">
        <p @click="activeted(21)" class="s2"><a :class="{active:flag==21}" href="#box21">test</a></p>
        <p @click="activeted(22)" class="s2"><a :class="{active:flag==22}" href="#box22">test</a></p>
        <p @click="activeted(23)" class="s2"><a :class="{active:flag==23}" href="#box23">test</a></p>
        <p @click="activeted(24)" class="s2"><a :class="{active:flag==24}" href="#box24">test</a></p>
        <p @click="activeted(25)" class="s2"><a :class="{active:flag==25}" href="#box25">test</a></p>
        <p @click="activeted(26)" class="s2"><a :class="{active:flag==26}" href="#box26">test</a></p>
        <p @click="activeted(27)" class="s2"><a :class="{active:flag==27}" href="#box27">test</a></p>
      </div> -->
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'matchingSystem',
  data() {
    return {
      flag: 1,
      show: false
    }
  },
  methods: {
    activeted(i) {
      console.log('i',i);
      this.flag = i
    }
  },
  mounted() {
    window.scroll(0, 0)
  }
}
</script>


<style lang="sass" scoped>
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
    .anchor1
      position: sticky
      top: 0px
      right: 0px
      padding: 0 15px
      padding-right: 0
      // width: 18%
      color: #525860
      font-size: 14px
      border-left: 1px solid #DADDE1
      .active  
        color: #7549A9
      .subAnchor
        padding: 0 15px
      a
        color: #525860
      a:hover
        color: #7549A9
        font-size: 15px
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
@media screen and (max-width:980px)
  .container
    display: flex
    .content
      overflow: auto
      // width: 75%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 60px
        margin-top: -60px
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 60px
        margin-top: -60px
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor1
      display: none
    .anchor2
      background: #F2F2F2
      border-radius: 5px
      color: #000
      padding: 10px 15px
      padding-right: 0
      // width: 25%
      font-size: 16px
      .clickArea
        padding-right: 15px
        color: #000
        display: flex
        justify-content: space-between
      .active  
        color: #7549A9
      .subAnchor
        padding-left: 15px
      a
        color: #525860
      a:hover
        color: #7549A9
      .s1
        margin: 10px 0
        line-height: 20px
        cursor: pointer
      .s2
        margin: 10px 0
        line-height: 20px
        cursor: pointer
        // word-break: break-all
</style>